import React, { useState } from "react";
import SkillsKey from "./SkillsKey";
import SkillsValue from "./SkillsValue";
import "./Skills.css";

import { FaNodeJs, FaJava, FaDatabase, FaAws, FaTools, FaBug, FaUserShield } from "react-icons/fa";
import { SiFrontendmentor,  SiPython } from "react-icons/si";

export const skills = {
  frontend: {
    icon: <SiFrontendmentor />,
    items: [
      { name: "HTML", level: "Expert" },
      { name: "CSS", level: "Expert" },
      { name: "JavaScript", level: "Expert" },
      { name: "React", level: "Expert" },
      { name: "Angular", level: "Intermediate" },
      { name: "Tailwind", level: "Expert" }
    ]
  },
  backend: {
    icon: <FaNodeJs />,
    items: [
      { name: "Spring Boot", level: "Expert" },
      { name: "T24 Development", level: "Intermediate" },
      { name: "Django", level: "Expert" },
      { name: "Node.js", level: "Intermediate" },
      { name: "Express.js", level: "Intermediate" }
    
    ]
  },
  languages: {
    icon: <FaJava />,
    items: [
      { name: "Java", level: "Expert" },
      { name: "JavaScript", level: "Expert" },
      { name: "TypeScript", level: "Intermediate" },
      { name: "InfoBacis", level: "Intermediate" },
      { name: "Shell Script", level: "Intermediate" },
      { name: "Python", level: "Intermediate" },
      { name: "Kotlin", level: "Beginner" },
      { name: "SQL", level: "Expert" }
    ]
  },
  databases: {
    icon: <FaDatabase />,
    items: [
      { name: "MySQL", level:"Expert" },
      { name: "PostgreSQL", level: "Intermediate" },
      { name: "MongoDB", level: "Intermediate" },
      { name: "Oracle", level: "Expert" }
    ]
  },
  devops: {
    icon: <SiPython />,
    items: [
      { name: "Docker", level: "Expert" },
      { name: "Kubernetes", level: "Intermediate" },
      { name: "Jenkins", level: "Intermediate" },
      { name: "GitHub Actions", level: "Expert" }
    ]
  },
  cloud: {
    icon: <FaAws />,
    items: [
      { name: "AWS", level: "Expert" },
      { name: "Azure", level: "Beginner" },
      { name: "Google Cloud", level: "Beginner" }
    ]
  },
  tools: {
    icon: <FaTools />,
    items: [
      { name: "Git", level: "Expert" },
      { name: "GitHub", level: "Expert" },
      { name: "VS Code", level: "Expert" },
      { name: "Grafana", level: "Expert" },
      { name: "Postman", level: "Expert" }
    ]
  },
  testing: {
    icon: <FaBug />,
    items: [
      { name: "JUnit", level: "Expert" },
      { name: "Selenium", level: "Intermediate" }
    ]
  },
  authentication: {
    icon: <FaUserShield />,
    items: [
      { name: "JWT", level: "Expert" },
      { name: "OAuth2", level: "Intermediate" },
      { name: "AWS Cognito", level: "Expert" },
      { name: "Firebase Auth", level: "Beginner" }
    ]
  }
};


// const skills = {
//   frontend: ["HTML", "CSS", "JavaScript", "React", "Angular", "Tailwind", "Next.js"],
//   backend: ["Node.js", "Express.js", "Spring Boot", "Django", "Flask"],
//   languages: ["Java", "JavaScript", "TypeScript", "Python", "Kotlin", "SQL"],
//   databases: ["MySQL", "PostgreSQL", "MongoDB", "Oracle"],
//   devops: ["Docker", "Kubernetes", "Jenkins", "GitHub Actions"],
//   cloud: ["AWS", "Azure", "Google Cloud"],
//   tools: ["Git", "GitHub", "VS Code", "Postman", "Figma"],
//   testing: ["Jest", "JUnit", "Selenium", "Cypress"],
//   authentication: ["JWT", "OAuth2", "AWS Cognito", "Firebase Auth"]
// };

const Skills = () => {
  const [selectedKey, setSelectedKey] = useState("frontend");

  return (
    <div className=" py-10">
      <div className=" pt-4 pb-4">
            <h1 className="text-4xl font-bold text-center">Technical Expertise</h1>
            <div className="w-20 h-1 bg-blue-600 mx-auto mt-2 rounded-full"></div>
            <h5 className=" mt-2 text-center font-bold mb-4">
          A comprehensive overview of my technical skills and areas of
          expertise, developed through years of hands-on experience.
        </h5>
          </div>
      {/* <div className="skills-heading text-center mb-8">
        <h1 className="text-3xl text-black font-bold">Technical Expertise</h1>
        <h5 className=" mt-2">
          A comprehensive overview of my technical skills and areas of
          expertise, developed through years of hands-on experience.
        </h5>
      </div> */}
      <div className="skills-container flex flex-row min-h-80 px-5">
        <div className="skills-left-block bg-slate-300 mr-5 min-w-[30%] rounded">
          <SkillsKey
            skillKeys={Object.keys(skills)}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
            skills={skills} 
          />
        </div>
        <div className="skills-right-block bg-slate-300 min-w-[65%] rounded">
          <SkillsValue skills={skills} selectedKey={selectedKey} />
        </div>
      </div>
    </div>
  );
};

export default Skills;
